import type { TranslateFn } from '../types/i18n';

/**
 * Veldzones. De `key` gaat over de API en blijft ongewijzigd; de kleur is opmaak.
 * De namen staan in `common:zones.*`, inclusief de korte vorm: die is een afkorting
 * van het vertaalde woord (K/V/M/A/W wordt G/D/M/F/S in het Engels).
 */
export interface ZoneConfig {
  key: string;
  color: string;
}

export const ZONE_CONFIGS: Record<string, ZoneConfig> = {
  goalkeeper: {
    key: 'goalkeeper',
    color: 'bg-green-100 text-green-800'
  },
  backs: {
    key: 'backs',
    color: 'bg-blue-100 text-blue-800'
  },
  midfield: {
    key: 'midfield',
    color: 'bg-yellow-100 text-yellow-800'
  },
  front: {
    key: 'front',
    color: 'bg-red-100 text-red-800'
  },
  subs: {
    key: 'subs',
    color: 'bg-gray-100 text-gray-800'
  }
};

/**
 * De zones die een formatiepositie kan hebben. 'subs' staat bewust niet in deze lijst:
 * een wisselspeler hoort bij een opstelling, niet bij een formatie.
 */
export const ZONE_KEYS = ['goalkeeper', 'backs', 'midfield', 'front'] as const;

export type FormationZone = (typeof ZONE_KEYS)[number];

// Helper functions for easy access
export const getZoneShortName = (t: TranslateFn, zoneKey: string): string =>
  t(`zones.${zoneKey}.short`, { defaultValue: zoneKey });

export const getZoneLongName = (t: TranslateFn, zoneKey: string): string =>
  t(`zones.${zoneKey}.long`, { defaultValue: zoneKey });

export const getZoneColor = (zoneKey: string): string => {
  return ZONE_CONFIGS[zoneKey]?.color || 'bg-gray-100 text-gray-800';
};
